export const checkPartnerName = async (value: string) => {
  if (!value) {
    return ''
  }

  return value.length >= 3 ? '' : 'Minimum 3 symbols'
}
